import { officeExtentions } from "../../config/constants";

export interface IOfficeContextApp {
    extention: string,
    name: string,
    filter: IOfficeContextApp_Filter
}

export interface IOfficeContextApp_Filter {
    items: string[];
    values: string;
}


export const GetOfficeContextApp = (): IOfficeContextApp => {
    const requirements = Office?.context?.requirements; 

    if (requirements) {
        if (requirements.isSetSupported("WordApi", "1.1")) {
            return {
                extention: "docx",
                name: "Word",
                filter: {
                    items: officeExtentions.word.items,
                    values: officeExtentions.word.values
                }
            };
        }
        else if (requirements.isSetSupported("ExcelApi", "1.1")) {
            return {
                extention: "xlsx", 
                name: "Excel", 
                filter: {
                    items: officeExtentions.excel.items,
                    values: officeExtentions.excel.values
                }
            };
        }
        else if (requirements.isSetSupported("PowerPointApi", "1.1")) {
            return {
                extention: "pptx", 
                name: "PowerPoint", 
                filter: {
                    items: officeExtentions.powerPoint.items,
                    values: officeExtentions.powerPoint.values
                }
            };
        }
    }

    return null;
}